export default __webpack_public_path__ + "static/acompanhamentos-7596991f4da2bf909688a24ee7a504c9.png";